export default {"src":"/_next/static/image/public/images/ic_empty_wishlist.a3c86b16f7c4bcb144833d95c3b14668.svg","height":143,"width":131};